module.exports = __webpack_public_path__ + "img/P150T_weapon_106.65d1929f.png";